import { defineComponent, h } from 'vue';
import { Modal, modalProps, ModalProps } from '@/ui/components/Modal';
import { createSquareButton } from '@/ui/components/Button';
import { t } from '@/ui/i18n/i18n';
import { CREATE_REPORT_MODAL_WIDTH } from '@/ui/components/modals/constants';
import { ReportPreMadeTemplate } from '@/services/api/resources/analytics-builder/constants';

interface CreateReportModalProps extends ModalProps {
  title: string;
}

export const CreateReportModal = defineComponent<CreateReportModalProps>({
  name: 'CreateReportModal',
  props: [...modalProps, 'title'],
  setup(props, context) {
    const closeModal = () => {
      context.emit('close');
    };

    const createFromScratch = () => {
      context.emit('scratchClick');
    };

    const createFromTemplate = (template: ReportPreMadeTemplate) => {
      context.emit('templateClick', template);
    };

    return function render() {
      return h(Modal, {
        props: {
          ...props,
          width: CREATE_REPORT_MODAL_WIDTH,
          ariaRole: 'dialog',
          trapFocus: true,
          destroyOnHide: false,
          ariaModal: true,
        },
        class: 'create-report-modal',
        on: {
          close: closeModal,
        },
      }, [
        h('h2', { class: 'title' }, props.title ?? t('analytics.create-report')),
        h('section', { class: 'create-report-modal__content' }, [
          createSquareButton(t('analytics.start-from-scratch'), createFromScratch),
          createSquareButton(t('analytics.responses-by-template'), () => createFromTemplate(ReportPreMadeTemplate.resultSummary),
            'is-light', false, 'flag-checkered'),
          createSquareButton(t('analytics.negative-responses'), () => createFromTemplate(ReportPreMadeTemplate.negativeResponses),
            'is-light', false, 'minus-circle'),
          createSquareButton(t('analytics.scores'), () => createFromTemplate(ReportPreMadeTemplate.scores),
            'is-light', false, 'trophy'),
          createSquareButton(t('analytics.overdue-inspections'), () => createFromTemplate(ReportPreMadeTemplate.overdueForms),
            'is-light', false, 'exclamation-square'),
          createSquareButton(t('analytics.issues'), () => createFromTemplate(ReportPreMadeTemplate.actions),
            'is-light', false, 'bullhorn'),
          createSquareButton(t('common.checklists'), () => createFromTemplate(ReportPreMadeTemplate.forms),
            'is-light', false, 'chart-line'),
        ]),
      ]);
    };
  },
});
